import moment from 'jalali-moment'
import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const getMoneyPoolManagement = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IMoneyPoolManagement } = await request.get(
        `/moneypool_management/moneypool/${ctx.queryKey[1]}/`
    )
    return data
}

export const getMoneyPoolManagementByWebKey = async (
    ctx: QueryFunctionContext
) => {
    const {
        data,
    }: {
        data: {
            moneypool_id: string
            moneypool_name: string
            share_value_amount: number
        }
    } = await request.get(
        `/moneypool_management/moneypool/web-key/${ctx.queryKey[1]}/`
    )
    return data
}

export const getJoinLinkByMoneypoolId = async (ctx: QueryFunctionContext) => {
    const { data }: { data: { join_link: string } } = await request.get(
        `/moneypool_management/moneypool/join-link/${ctx.queryKey[1]}/`
    )
    return data
}

export const getMoneyPoolManagementBulletins = async (
    ctx: QueryFunctionContext
) => {
    const { data }: { data: Array<IBulletiens> } = await request.get(
        `/moneypool_management/bulletins/${ctx.queryKey[1]}/`
    )
    return data
}

export const getMonyPoolsDetailUsers = async (
    pageParam: number,
    id: string | undefined,
    search: string | undefined
) => {
    console.log('search', search)
    const { data }: { data: IGetMoneyPoolUsers } = await request.get(
        `/api/v1/moneypools/${id}/poolships/?cursor=${pageParam}${
            search ? '&q=' + search : ''
        }`
    )
    return data
}

export const getMonyPoolsDetailTransactions = async (
    ctx: QueryFunctionContext
) => {
    const { data }: { data: IMoneyPoolTransaction } = await request.get(
        `/moneypool_management/moneypool/${
            ctx.queryKey[1]
        }/list-cashins-and-cashouts/${
            ctx.queryKey[2] ? '?q=' + ctx.queryKey[2] : ''
        }`
    )
    return data
}

export const getMonyPoolsDetailLoans = async (
    pageParams: number,
    id: undefined | string,
    searchLoans: string
) => {
    const { data }: { data: IMoneyPoolFundLoans } = await request.get(
        `/api/v1/moneypools/${id}/loans/?page=${pageParams}${
            searchLoans ? '&q=' + searchLoans : ''
        }`
    )
    return data
}

export const deleteMoneyPoolCashin = async ({
    moneypoolId,
    cashinId,
}: {
    moneypoolId: number
    cashinId: number
}) => {
    const response = await request.delete(
        `/api/v1/payment/moneypools/${moneypoolId}/moneypool-cashins/${cashinId}/`
    )
    return response
}
export const deleteMoneyPoolCashout = async ({
    moneypoolId,
    cashoutId,
}: {
    moneypoolId: number
    cashoutId: number
}) => {
    const response = await request.delete(
        `/api/v1/payment/moneypools/${moneypoolId}/moneypool-cashouts/${cashoutId}/`
    )
    return response
}
export const getFacilitiesExportExcel = async (
    moneyPool: string | undefined
) => {
    const { data }: { data: IReportFacilitiesExcel } = await request.get(
        `/api/v1/moneypools/${moneyPool}/facilities/`
    )
    return data
}

export const getFinancialDashboard = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IFinancialDashboard } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/financial-dashboard/`
    )
    return data
}

export const ReportEmailExcel = async (
    payload: IFacilitiesReportExcelEmail
) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPool}/facilities/report/`,
        { email: payload.email }
    )
    return data
}

export const getFacilitiesExportExcelDownload = async (
    moneyPool: string | undefined
) => {
    const { data } = await request.get(
        `/api/v1/moneypools/${moneyPool}/facilities/report/download/`
    )
    return data
}

export const ReportEmailExcelCheckTask = async (
    payload: string | undefined
) => {
    const { data } = await request.post(`/api/v1/general/check-task-status/`, {
        task_id: payload,
    })
    return data
}
export const getFacilitiesExportExcelDownloadFinal = async (
    task: string | undefined
) => {
    const { data } = await request.get(
        `/api/v1/general/download-task-result/${task}/`
    )
    return data
}

export const addUserTofund = async (payload: IAddNewUserToFundPayload) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPool}/poolships/`,
        {
            member: {
                has_rated: false,
                is_box_member: false,
                l: [],
                id: 0,
                phone_number: '+98' + payload.phone_number.slice(1),
                first_name: payload.first_name,
                last_name: payload.last_name,
                global_credit: 0.0,
                last_global_credit: -10000.0,
                global_score: 0.0,
                last_global_score: 0.0,
                is_staff: false,
                show_marketing_banner: false,
            },
            number_of_shares: Number(payload.number_of_shares),
            role: 'nrm',
            join_date: moment().format('YYYY-MM-DD'),
            to_be_paid_portion: 0,
            ...(payload.recommender && { recommender: payload.recommender }),
            ...(payload.guarantor && { guarantor: payload.guarantor }),
        }
    )
}

export const addUserToFundByLink = async (
    payload: IAddNewUserToFundPayload
) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.moneyPool}/poolship/join_moneypool_by_link/`,
        {
            member: {
                id: 0,
                phone_number: '+98' + payload.phone_number.slice(1),
                first_name: payload.first_name,
                last_name: payload.last_name,
            },
            number_of_shares: Number(payload.number_of_shares),
            ...(payload.recommender && { recommender: payload.recommender }),
            ...(payload.guarantor && { guarantor: payload.guarantor }),
        }
    )
    return data
}

export const getUserLoansDetail = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IUserloansDetail } = await request.get(
        `/moneypool_management/${ctx.queryKey[1]}/installment/list/${ctx.queryKey[2]}/`
    )
    return data
}

export const addBulletin = async (payload: IAddBulletinPayload) => {
    const { data } = await request.post(
        `/moneypool_management/bulletins/${payload.id}/create`,
        {
            text: payload.text,
            sticker: 3,
        }
    )
    return { data }
}

export const deleteBulletin = async (payload: {
    moneypoolId: string | undefined
    id: number
}) => {
    const response = await request.delete(
        `/moneypool_management/bulletins/${payload.moneypoolId}/${payload.id}/delete`
    )
    return response
}

export const updatePortion = async (payload: {
    moneyPool: String | undefined
    poolship: number
    amount: number
    is_delayed: boolean
}) => {
    const { data } = await request.put(
        `/api/v1/moneypools/${payload.moneyPool}/poolships/${payload.poolship}/reset_poolship_portions/`,
        {
            amount: payload.amount,
            is_delayed: payload.is_delayed,
        }
    )
    return data
}

export const getUnpaidSiblings = async (ctx: QueryFunctionContext) => {
    const { data }: { data: Array<number> } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/loans/${ctx.queryKey[2]}/installments/${ctx.queryKey[3]}/unpaid_siblings/`
    )
    return data
}

export const transferInstalment = async (payload: {
    source_instalment_id: string | undefined
    destination_instalment_index: number
    amount: number
    moneyPools: string | undefined
    loans: string | undefined
}) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPools}/loans/${payload.loans}/transfer_installment_amount/`,
        {
            source_installment_id: Number(payload.source_instalment_id),
            destination_installment_index: Number(
                payload.destination_instalment_index
            ),
            amount: Number(payload.amount),
        }
    )
    return { data }
}
